import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import {PropertyClearUIListenerParams} from '#/DefaultViewExtensionInterfaces';

export default class RADAzureADConnectionUIListener extends UIListener {

    constructor() {
        super();

        this.createChain(
            this.createPropertyClearUIListener(),
        );
    }

    private createPropertyClearUIListener() {
        const params: PropertyClearUIListenerParams = {
            rules: [
                {
                    propertiesToWatch: ['TenantId', 'ClientId'],
                    propertiesToClear: ['DecryptedClientSecret']
                }
            ]
        };
        return {
            uiListener: 'PropertyClearUIListener',
            params: params
        };
    }
}

ComponentManager.setUIListener('RADAzureADConnectionUIListener', RADAzureADConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.RADAzureADConnectionUIListener', RADAzureADConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');